import { useEffect, useState } from "react";
import { X } from "lucide-react";

const STORAGE_KEY = "kvkk_consent_v1";

export default function KVKKBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const consent = localStorage.getItem(STORAGE_KEY);
      if (!consent) {
        const t = setTimeout(() => setVisible(true), 400);
        return () => clearTimeout(t);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const persist = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch {
      /* ignore storage errors */
    }
  };

  const accept = () => {
    persist("accepted");
    setVisible(false);
  };

  const dismiss = () => {
    persist("dismissed");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="kvkk-banner"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-6 lg:right-6 lg:left-auto lg:max-w-[520px] z-50 bg-anthracite text-white shadow-2xl animate-fade-up"
    >
      <div className="h-[2px] bg-gold" />
      <div className="p-5 md:p-6 relative">
        <button
          data-testid="kvkk-dismiss-button"
          onClick={dismiss}
          aria-label="Kapat"
          className="absolute top-3 right-3 text-white/60 hover:text-gold transition-colors"
        >
          <X size={16} />
        </button>

        <div className="overline text-gold/90 mb-2">Çerez / KVKK</div>
        <h3 className="font-heading text-[16px] font-medium mb-2 text-white">
          Web sitemizde çerezler kullanılmaktadır.
        </h3>
        <p className="text-[12.5px] leading-relaxed text-white/70 pr-6">
          Web sitemizin işlevselliğini artırmak ve hizmet kalitemizi geliştirmek
          amacıyla çerezler kullanıyoruz. Detaylı bilgi için{" "}
          <a href="#" className="text-gold underline underline-offset-2 hover:text-white">
            KVKK Aydınlatma Metnini
          </a>{" "}
          inceleyebilirsiniz.
        </p>

        <div className="mt-5 flex flex-col sm:flex-row gap-3">
          <button
            data-testid="kvkk-accept-button"
            onClick={accept}
            className="inline-flex items-center justify-center gap-2 bg-gold hover:bg-gold-hover text-white px-5 py-2.5 text-[12px] font-medium tracking-widest uppercase transition-colors"
          >
            Kabul Ediyorum
          </button>
          <button
            data-testid="kvkk-decline-button"
            onClick={dismiss}
            className="inline-flex items-center justify-center gap-2 border border-white/30 hover:border-gold text-white/85 hover:text-gold px-5 py-2.5 text-[12px] font-medium tracking-widest uppercase transition-colors"
          >
            Sadece Zorunlu
          </button>
        </div>
      </div>
    </div>
  );
}
